/**
 * This is default flickity carousel class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
import Flickity from "flickity";
import {
  flickityReadyHandler,
  flickityChangeHandler,
  flickitySettleHandler,
} from "../utils/flickity";

export default class Carousel {
  constructor(elem, APP) {
    this.elem = elem;
    this.carousel = this.elem.querySelector(".js-slider");
    this.slides = this.elem.querySelectorAll(".js-slide");
    this.slideIndex = this.elem.querySelector(".js-slider-index");
    this.slideTotal = this.elem.querySelector(".js-slider-total");
    // this.dots;
    this.slideHeight = 0;
    this.flkty;
    this.currentSlideIndex = 0;

    // todo
    // this.bgs = this.elem.parentElement.querySelectorAll(".js-spf-img");
    this.windowWidth = window.innerWidth;
  }

  resizeCarousel() {
    if(this.windowWidth != window.innerWidth) {
      // this.flkty.destroy();
      // this.setupCarousel();

      // this.slideHeight = 0;
      this.windowWidth = window.innerWidth;
    }
  }

  setupCarousel() {
    this.flkty = new Flickity(this.carousel, {
      // setGallerySize: false,
      accessibility: false,
      prevNextButtons: this.elem.dataset.length > 1,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "center",
      wrapAround: true,
      groupCells: true,
      // contain: true,
      on: {
        ready: () => {
          if(this.elem.dataset.length > 1) {
            this.slideTotal.innerText = this.slides.length;
          }
          // this.dots = this.elem.querySelectorAll(".flickity-page-dots button");
          // flickityReadyHandler(this.carousel, this.dots);
        },
        change: (index) => {
          if(this.elem.dataset.length > 1) {
            this.slideIndex.innerText = index + 1;
          }

          this.currentSlideIndex = index;
          // this.flkty.resize();
          // flickityChangeHandler(this.dots, index);

          // if(this.bgs) {
          //   this.bgs.forEach((bg, i) => {
          //     if(index.toString() == bg.dataset.id) {
          //       bg.classList.add('active');
          //     } else {
          //       bg.classList.remove('active');
          //     }
          //   })
          // }
        },
        settle: () => {
          flickitySettleHandler(
            this.carousel.querySelectorAll(".js-slide")
          );

        },
      },
    });
  }

  init() {
    this.setupCarousel();

    // window.addEventListener("resize", () => {
    //   this.resizeCarousel();
    // })
  }
}
